export default __webpack_public_path__ + "static/1.2-715e30c9572d4257054265ee94f18e8b.webp";